// Cute hand-drawn potato character SVGs (replacing ting's astronaut & donut)
import React from 'react';

export const PotatoHero = ({ className = '' }) => (
  <svg viewBox="0 0 260 320" className={className} xmlns="http://www.w3.org/2000/svg">
    {/* body */}
    <path d="M60,150 C50,80 110,30 165,45 C220,58 235,120 220,180 C210,240 170,285 120,280 C70,275 45,220 60,150 Z" fill="#D4A574" stroke="#3a2210" strokeWidth="4"/>
    {/* shadow bumps */}
    <ellipse cx="90" cy="200" rx="12" ry="6" fill="#b78659" opacity="0.6"/>
    <ellipse cx="180" cy="100" rx="10" ry="5" fill="#b78659" opacity="0.6"/>
    <ellipse cx="195" cy="210" rx="9" ry="5" fill="#b78659" opacity="0.6"/>
    {/* eyes */}
    <circle cx="115" cy="140" r="14" fill="#fff" stroke="#3a2210" strokeWidth="3"/>
    <circle cx="175" cy="135" r="14" fill="#fff" stroke="#3a2210" strokeWidth="3"/>
    <circle cx="118" cy="143" r="5" fill="#111"/>
    <circle cx="178" cy="138" r="5" fill="#111"/>
    <circle cx="120" cy="140" r="2" fill="#fff"/>
    <circle cx="180" cy="135" r="2" fill="#fff"/>
    {/* smile */}
    <path d="M120,180 Q145,205 175,180" stroke="#3a2210" strokeWidth="4" fill="none" strokeLinecap="round"/>
    {/* cheeks */}
    <circle cx="95" cy="170" r="7" fill="#FF9AA2" opacity="0.7"/>
    <circle cx="200" cy="165" r="7" fill="#FF9AA2" opacity="0.7"/>
    {/* arms - waving */}
    <path d="M55,160 Q20,140 15,100" stroke="#3a2210" strokeWidth="5" fill="none" strokeLinecap="round"/>
    <circle cx="15" cy="98" r="10" fill="#D4A574" stroke="#3a2210" strokeWidth="3"/>
    <path d="M225,160 Q255,190 245,235" stroke="#3a2210" strokeWidth="5" fill="none" strokeLinecap="round"/>
    <circle cx="245" cy="235" r="10" fill="#D4A574" stroke="#3a2210" strokeWidth="3"/>
    {/* legs */}
    <path d="M110,280 L105,310" stroke="#3a2210" strokeWidth="5" strokeLinecap="round"/>
    <path d="M155,282 L160,312" stroke="#3a2210" strokeWidth="5" strokeLinecap="round"/>
    <ellipse cx="100" cy="312" rx="12" ry="5" fill="#3a2210"/>
    <ellipse cx="165" cy="314" rx="12" ry="5" fill="#3a2210"/>
  </svg>
);

export const PotatoChip = ({ className = '' }) => (
  <svg viewBox="0 0 120 120" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M20,45 C15,25 40,10 65,15 C95,20 110,45 105,70 C100,95 80,110 55,105 C30,100 25,75 20,45 Z" fill="#FFD200" stroke="#3a2210" strokeWidth="3"/>
    <circle cx="45" cy="50" r="3" fill="#3a2210"/>
    <circle cx="75" cy="70" r="3" fill="#3a2210"/>
    <circle cx="60" cy="85" r="2" fill="#3a2210"/>
    <circle cx="85" cy="40" r="2" fill="#3a2210"/>
  </svg>
);

export const Sparkle = ({ className = '', color = '#FFD200' }) => (
  <svg viewBox="0 0 40 40" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M20,2 L23,17 L38,20 L23,23 L20,38 L17,23 L2,20 L17,17 Z" fill={color} stroke="#111" strokeWidth="1.5"/>
  </svg>
);

export const Squiggle = ({ className = '' }) => (
  <svg viewBox="0 0 200 20" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M2,10 Q25,-2 50,10 T100,10 T150,10 T198,10" stroke="#111" strokeWidth="3" fill="none" strokeLinecap="round"/>
  </svg>
);

export const Arrow = ({ className = '' }) => (
  <svg viewBox="0 0 32 32" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M6,16 L26,16 M18,8 L26,16 L18,24" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const PotatoAvatar = ({ seed = 0, className = '' }) => {
  const shades = ['#D4A574','#C8925C','#E0B584','#BE884E','#D9AE7A','#C79968','#EAC090','#B78659'];
  const c = shades[seed % shades.length];
  const eyeY = 50 + (seed % 3) * 2;
  return (
    <svg viewBox="0 0 140 140" className={className} xmlns="http://www.w3.org/2000/svg">
      <path d="M30,70 C25,35 60,15 85,20 C115,25 125,55 118,90 C112,120 85,132 60,128 C35,124 25,100 30,70 Z" fill={c} stroke="#3a2210" strokeWidth="3"/>
      <circle cx="58" cy={eyeY} r="7" fill="#fff" stroke="#3a2210" strokeWidth="2"/>
      <circle cx="92" cy={eyeY - 2} r="7" fill="#fff" stroke="#3a2210" strokeWidth="2"/>
      <circle cx="59" cy={eyeY + 1} r="3" fill="#111"/>
      <circle cx="93" cy={eyeY - 1} r="3" fill="#111"/>
      <path d={`M55,${eyeY + 25} Q75,${eyeY + 40} 95,${eyeY + 22}`} stroke="#3a2210" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
      <circle cx="45" cy={eyeY + 15} r="4" fill="#FF9AA2" opacity="0.7"/>
      <circle cx="105" cy={eyeY + 13} r="4" fill="#FF9AA2" opacity="0.7"/>
    </svg>
  );
};
